module.exports = __webpack_public_path__ + "static/media/Zimbabwe.ffc5984a.png";